module.exports = __webpack_public_path__ + "static/media/pic12.8e883b35.jpg";